/*
 * @Description:
 * @Date: 2019-07-31 16:11:15
 */
import axios from 'axios';
import dateFormat from '@/tools/dateFormat.js';
import querystring from 'querystring';
import Config from '@/config/index';
import echarts from 'echarts';
import { v4 as uuidv4 } from 'uuid';
import xrkDialog from '@/components/Dialog/main.js';
import * as methods from '@/methods/index';
import sa from '@/public/sa';
import md5 from 'md5';

export default {
  install(Vue) {
    //AJAX
    Vue.prototype.$http = axios;
    Vue.http = axios;

    //时间格式
    Vue.prototype.$dateFormat = dateFormat;
    Vue.prototype.$qiniuPath = 'http://cdn1.yxvzb.com/';
    Vue.prototype.$querystring = querystring;
    Vue.prototype.$Config = Config;
    Vue.prototype.$echarts = echarts;
    Vue.prototype.$uuidv4 = uuidv4;
    Vue.prototype.$xrkDialog = xrkDialog;
    Vue.prototype.$md5 = md5;
    Vue.prototype.$sa = new sa();
    Object.keys(methods).forEach(key => {
      Vue.prototype[`$${key}`] = methods[key];
    });
  },
  $http: axios
};
